var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNivelesDeComplejidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 158.333V108.333C75 106.123 74.122 104.004 72.5592 102.441C70.9964 100.878 68.8768 100 66.6667 100H33.3333C31.1232 100 29.0036 100.878 27.4408 102.441C25.878 104.004 25 106.123 25 108.333V158.333C25 160.543 25.878 162.663 27.4408 164.226C29.0036 165.789 31.1232 166.667 33.3333 166.667M75 158.333C75 160.543 74.122 162.663 72.5592 164.226C70.9964 165.789 68.8768 166.667 66.6667 166.667H33.3333M75 158.333C75 160.543 75.878 162.663 77.4408 164.226C79.0036 165.789 81.1232 166.667 83.3333 166.667H116.667C118.877 166.667 120.996 165.789 122.559 164.226C124.122 162.663 125 160.543 125 158.333M75 158.333V75C75 72.7899 75.878 70.6703 77.4408 69.1075C79.0036 67.5447 81.1232 66.6667 83.3333 66.6667H116.667C118.877 66.6667 120.996 67.5447 122.559 69.1075C124.122 70.6703 125 72.7899 125 75V158.333M33.3333 166.667H150M125 158.333C125 160.543 125.878 162.663 127.441 164.226C129.004 165.789 131.123 166.667 133.333 166.667H166.667C168.877 166.667 170.996 165.789 172.559 164.226C174.122 162.663 175 160.543 175 158.333V41.6667C175 39.4565 174.122 37.3369 172.559 35.7741C170.996 34.2113 168.877 33.3333 166.667 33.3333H133.333C131.123 33.3333 129.004 34.2113 127.441 35.7741C125.878 37.3369 125 39.4565 125 41.6667V158.333Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivelesDeComplejidad);
export default __webpack_public_path__ + "static/media/NivelesDeComplejidad.8af6f3d8185905212ac497174901cb1c.svg";
export { ForwardRef as ReactComponent };